import React, { useState, useEffect, useReducer } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MultiSelectWithCreate from "Components/MultiSelect";
// Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";
// import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";
import TextArea from "Components/TextArea";

// redux
import { useDispatch, useSelector } from "react-redux";
import { uploadMultiple, uploadSingle } from "../../../../Redux/Slices/mainSlice";
import { addProduct, editProduct, fetchIndividualProduct, fetchProductCatalogCategory, fetchProductCatalogSubCategory, fetchProductCatalogType } from "../../../../Redux/Slices/productCatalogSlice";
import { set } from "react-hook-form";

const initialState = {
  designation: '',
  suffix: '',
  performance_class: '',
  radial_internal_clearance_um: '',
  features: '',
  bearing_type: '',
  bore_size_d_mm: '',
  outside_diameter_d_mm: '',
  outside_ring_width_b_mm: '',
  radius_rs_min_mm: '',
  dynamic_load_rating_cr_n: '',
  static_load_rating_c0r_n: '',
  reference_speed_rpm: '',
  limiting_speed_rpm: '',
  mass_kg: '',
};

const formReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FIELD':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'RESET':
      return initialState;
    default:
      return state
  }
}

const EditProductCatalog = () => {
  const { id, category_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedType, setSetType] = useState(null);
  const [fileCad, setFileCad] = useState("");
  const [multiFile, setMultiFile] = useState([]);
  const [productName, setProductName] = useState("");
  const [productBrand, setProductBrand] = useState("")
  const [productSubBrand, setProductSubBrand] = useState("")
  const [baldwin, setBaldwin] = useState("")
  const [fleetguard, setFleetguard] = useState("")
  const [hifi, setHifi] = useState("")
  const [sakura, setSakura] = useState("")
  const [donaldson, setDonaldson] = useState("")
  const [hengst, sethengst] = useState("")
  const [wix, setWix] = useState("")
  const [mann, setMann] = useState("")
  const [gearboxTorqueRange, setGearboxTorqueRange] = useState("");
  const [gearboxRatios, setGearboxRatios] = useState("");
  const [gearboxMechanicalRating, setGearboxMechanicalRating] = useState("");
  const [gearboxSizes, setGearboxSizes] = useState([]);
  const [gearboxInput, setGearboxInput] = useState("");
  const [gearboxOutput, setGearboxOutput] = useState("");
  const [maxViscosity, setMaxViscosity] = useState("");
  const [mountingConnection, setMountingConnection] = useState("");
  const [housingOption, setHousingOption] = useState({ label: "Yes", value: "Yes" });
  const [productOptions, setProductOptions] = useState([]);
  const [description, setDescription] = useState("");
  const [maxFlowrate, setMaxFlowRate] = useState("")
  const [workingPressure, setWorkingPressure] = useState("")
  const [ratedStaticburst, setRatedStaticBurst] = useState("")

  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [type, setType] = useState([]);
  const [hasSetSubCategory, setHasSetSubCategory] = useState(false); // Flag to track if subCategory is set
  const [existingSubCategory, setExistingSubCategory] = useState()
  const [state, formDispatch] = useReducer(formReducer, initialState)



  const isUploading = useSelector((state) => state.main.isLoading);
  const dropDownStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #B2BEC3",
      boxShadow: "none",
      padding: "5px 3px",
      fontFamily: "Poppins",
      fontSize: "2.2vh",
      marginRight: "10px",
      height: "7vh",
    }),
    menu: (provided) => ({
      ...provided,
      color: "#697077",
    }),
    option: (provided) => ({
      ...provided,
      color: "#697077",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const inputBoxStyles = {
    boxShadow: "none",
    border: "1px solid #B2BEC3",
    padding: "1px 2vh 1px 2vh",
    height: "7vh",
    color: "black"
  };

  const inputBoxDesStyles = {
    boxShadow: "none",
    border: "1px solid #B2BEC3",
    padding: "1px 5vh 1px 2vh",
    height: "17vh",
    fontSize: "2.2vh",
    color: "black",
  };

  const handleDropDownChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    const selectedCategory = category.find(
      (item) => item.category_id === selectedOption.value
    );
    if (selectedCategory) {
      const categoryId = selectedCategory.category_id;
      const getSubCategoryCB = (value) => {
        // console.log(value)
        if (value.data.length !== 0) {
          const updatedSubCategories = value.data.map((item) => ({
            ...item,
            label: item.sub_category_name,
            value: item.sub_category_id,
          }));
          setSubCategory(updatedSubCategories);
        } else {
          setSubCategory([]);
        }
      };
      dispatch(
        fetchProductCatalogSubCategory({
          data: categoryId,
          callBack: getSubCategoryCB,
        })
      );
    }
  };

  const handleFileChange = (event) => {
    // console.log(event.target.files)
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    const uploadCB = (value) => {
      setFileCad(value.data.url);
      event.target.value = null; // Clear the previous file value
    };

    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleMultipleFileChange = (event) => {
    // const selectedFiles = event.target.files;
    // console.log(selectedFiles);  
    const files = event.target.files;
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const uploadCB = (value) => {
      // Handle the response, e.g., save URLs of uploaded files
      const uploadedFiles = value.data;
      // console.log("Uploaded files:", uploadedFiles);
      const formatChangedArray = uploadedFiles.map((item) => {
        return (
          {
            "product_catalog_images": item.url,
            "isAdded": true,
            "isDeleted": false,
            // "product_catalog_id": id
          }
        )
      })
      setMultiFile((prevMultiFile) => [...prevMultiFile, ...formatChangedArray]);
    };

    dispatch(
      uploadMultiple({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleValidation = () => {
    let validationErrors = {};

    // if (Number(category_id) === 4) {
    //     const productNameValidation = validateInput("productName", productName);
    //     if (productNameValidation.productName) {
    //       validationErrors.productName = productNameValidation.productName;
    //     }

    //     const torqueRangeValidation = validateInput("gearboxTorqueRange", gearboxTorqueRange);
    //     if (torqueRangeValidation.gearboxTorqueRange) {
    //       validationErrors.gearboxTorqueRange = torqueRangeValidation.gearboxTorqueRange;
    //     }

    //     const ratiosValidation = validateInput("gearboxRatios", gearboxRatios);
    //     if (ratiosValidation.gearboxRatios) {
    //       validationErrors.gearboxRatios = ratiosValidation.gearboxRatios;
    //     }

    //     const mechanicalRatingValidation = validateInput("gearboxMechanicalRating", gearboxMechanicalRating);
    //     if (mechanicalRatingValidation.gearboxMechanicalRating) {
    //       validationErrors.gearboxMechanicalRating = mechanicalRatingValidation.gearboxMechanicalRating;
    //     }

    //     const inputValidation = validateInput("gearboxInput", gearboxInput);
    //     if (inputValidation.gearboxInput) {
    //       validationErrors.gearboxInput = inputValidation.gearboxInput;
    //     }

    //     const outputValidation = validateInput("gearboxOutput", gearboxOutput);
    //     if (outputValidation.gearboxOutput) {
    //       validationErrors.gearboxOutput = outputValidation.gearboxOutput;
    //     }

    //     const gearboxSizesValidation = validateInput("gearboxSizes", gearboxSizes);
    //     if (gearboxSizesValidation.gearboxSizes) {
    //       validationErrors.gearboxSizes = gearboxSizesValidation.gearboxSizes;
    //     }

    //   } 

    //   if (Number(category_id) !== 4) {


    //     const productLearningType = validateInput("selectedType", selectedType);
    //     if (productLearningType.selectedType) {
    //       validationErrors.selectedType = productLearningType.selectedType;
    //     }

    // if (selectedType?.value === 2) {

    //   const validateMaxFlowrate = validateInput("maxFlowrate", maxFlowrate);
    //   if (validateMaxFlowrate.maxFlowrate) {
    //     validationErrors.maxFlowrate = validateMaxFlowrate.maxFlowrate;
    //   }

    //   const validateWorkingPressure = validateInput("workingPressure", workingPressure);
    //   if (validateWorkingPressure.workingPressure) {
    //     validationErrors.workingPressure = validateWorkingPressure.workingPressure;
    //   }

    //   const validateRatedStaticburst = validateInput("ratedStaticburst", ratedStaticburst);
    //   if (validateRatedStaticburst.ratedStaticburst) {
    //     validationErrors.ratedStaticburst = validateRatedStaticburst.ratedStaticburst;
    //   }

    //   const validateMaxViscosity = validateInput("maxViscosity", maxViscosity);
    //   if (validateMaxViscosity.maxViscosity) {
    //     validationErrors.maxViscosity = validateMaxViscosity.maxViscosity;
    //   }

    //   const validateMountingConnection = validateInput("mountingConnection", mountingConnection);
    //   if (validateMountingConnection.mountingConnection) {
    //     validationErrors.mountingConnection = validateMountingConnection.mountingConnection;
    //   }

    //   const validateHousingOption = validateInput("housingOption", housingOption);
    //   if (validateHousingOption.housingOption) {
    //     validationErrors.housingOption = validateHousingOption.housingOption;
    //   }

    //   const validateProductOptions = validateInput("productOptions", productOptions);
    //   if (validateProductOptions.productOptions) {
    //     validationErrors.productOptions = validateProductOptions.productOptions;
    //   }


    //   const validateDescription = validateInput("description", description);
    //   if (validateDescription.description) {
    //     validationErrors.description = validateDescription.description;
    //   }
    // } else {
    //   // Validate Baldwin and Fleetguard for filtration type

    //   const productSubCategory = validateInput("sub_category", selectedSubCategory);
    //     if (productSubCategory.sub_category) {
    //       validationErrors.sub_category = productSubCategory.sub_category;
    //     }
    //     const validateHifi = validateInput("hifi", hifi);
    //     if (validateHifi.hifi) {
    //       validationErrors.hifi = validateHifi.hifi;
    //     }
    //     const validateSakura = validateInput("sakura", sakura);
    //     if (validateSakura.sakura) {
    //       validationErrors.sakura = validateSakura.sakura;
    //     }
    //     const validateDonaldson = validateInput("donaldson", donaldson);
    //     if (validateDonaldson.donaldson) {
    //       validationErrors.donaldson = validateDonaldson.donaldson;
    //     }
    //     const validateHengst = validateInput("hengst", hengst);
    //     if (validateHengst.hengst) {
    //       validationErrors.hengst = validateHengst.hengst;
    //     }
    //     const validateWix = validateInput("wix", wix);
    //     if (validateWix.wix) {
    //       validationErrors.wix = validateWix.wix;
    //     }
    //     const validateMann = validateInput("Mann", mann);
    //     if (validateMann.mann) {
    //       validationErrors.mann = validateMann.mann;
    //     }

    //   const validateBaldwin = validateInput("baldwin", baldwin);
    //   if (validateBaldwin.baldwin) {
    //     validationErrors.baldwin = validateBaldwin.baldwin;
    //   }
    //   const validateFleetguard = validateInput("fleetguard", fleetguard);
    //   if (validateFleetguard.fleetguard) {
    //     validationErrors.fleetguard = validateFleetguard.fleetguard;
    //   }
    // }
    //   }

    //   const productCategory = validateInput("category", selectedCategory);
    //   if (productCategory.category) {
    //     validationErrors.category = productCategory.category;
    //   }

    const productLearningTitle = validateInput("productName", productName);
    if (productLearningTitle.productName) {
      validationErrors.productName = productLearningTitle.productName;
    }

    setErrors(validationErrors);
    console.log(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      // Base data object with common fields
      let data = {
        "product_catalog_id": id,
        "category_id": selectedCategory?.category_id,
        "category_name": selectedCategory?.category_name,
        "product_name": productName,
        "product_catalog_images": multiFile,
      };

      // Add category specific fields based on category_id
      if (Number(category_id) === 4) {
        // Add Gearbox/Motors specific fields
        data = {
          ...data,
          "gearbox_torque_range": gearboxTorqueRange,
          "gearbox_ratios": gearboxRatios,
          "gearbox_mechanical_rating": gearboxMechanicalRating,
          "gearbox_input": gearboxInput,
          "gearbox_output": gearboxOutput,
          //  "gearbox_sizes": gearboxSizes.length > 0 ? gearboxSizes.join: null
          "gearbox_sizes": gearboxSizes,
        };
      }
      else if (Number(category_id) === 1) {
        data = {
          ...data,
          designation: state.designation,
          suffix: state.suffix,
          performance_class: state.performance_class,
          radial_internal_clearance_um: state.radial_internal_clearance_um,
          features: state.features,
          bearing_type: state.bearing_type,
          bore_size_d_mm: state.bore_size_d_mm,
          outside_diameter_d_mm: state.outside_diameter_d_mm,
          outside_ring_width_b_mm: state.outside_ring_width_b_mm,
          radius_rs_min_mm: state.radius_rs_min_mm,
          dynamic_load_rating_cr_n: state.dynamic_load_rating_cr_n,
          static_load_rating_c0r_n: state.static_load_rating_c0r_n,
          reference_speed_rpm: state.reference_speed_rpm,
          limiting_speed_rpm: state.limiting_speed_rpm,
          mass_kg: state.mass_kg,

        }
      }
      else {
        // Add fields for other categories
        data = {
          ...data,
          "filteration_type_id": selectedType?.value || null,
          "filteration_type_name": selectedType?.label || null,

          ...(selectedType?.value === 1 ? {
            sub_category_id: selectedSubCategory?.sub_category_id || null,
            sub_category_name: selectedSubCategory?.sub_category_name || null,
            baldwin: baldwin,
            fleetguard: fleetguard,
            hifi: hifi,
            sakura: sakura,
            donaldson: donaldson,
            hengst: hengst,
            wix: wix,
            mann: mann,
          } : {
            max_flow_rate: maxFlowrate,
            working_pressure: workingPressure,
            rated_static_burst: ratedStaticburst,
            max_viscosity: maxViscosity,
            mounting_connection: mountingConnection,
            housing_option_available: housingOption.value === "Yes",
            // product_option: typeof productOptions === 'string'
            // ? productOptions.split(",").map((val) => ({
            //     label: val.trim().toUpperCase().replace(/\s+/g, '_'),
            //     value: val.trim()
            //   }))
            // : productOptions,                  
            description: description,
          })
        };
      }

      // Add optional common fields
      if (productBrand) {
        data.product_brand_name = productBrand;
      }
      if (productSubBrand) {
        data.product_sub_brand_name = productSubBrand;
      }
      if (fileCad) {
        data.upload_cad_drawing = fileCad;
      }

      const editProductCB = () => {
        setIsSuccess(true);
      };

      dispatch(
        editProduct({
          id,
          data: data,
          callBack: editProductCB,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      fetchProductCatalogCategory({
        callBack: getCategoryCB,
      })
    );
    dispatch(
      fetchProductCatalogType({
        callBack: getTypeCB
      })
    )
  }, []);

  useEffect(() => {
    if (category.length > 0) {
      dispatch(
        fetchIndividualProduct({
          data: Number(category_id) === 1 ? { id } : { id, category_id },
          callBack: getProductDataCB
        })
      )
    }
  }, [category, type])

  useEffect(() => {
    // Only set subCategory once after the component first renders and subCategories are fetched
    if (!hasSetSubCategory && subCategory.length > 0) {
      const matchingSubCategory = subCategory.find(
        (item) => item.sub_category_id === existingSubCategory
      );
      if (matchingSubCategory) {
        setSelectedSubCategory(matchingSubCategory);
        setHasSetSubCategory(true); // Set the flag to true after setting it initially
      }
    }
  }, [subCategory, hasSetSubCategory, existingSubCategory]);

  const getCategoryCB = (value) => {
    // console.log(value)
    const updatedCategories = value.data.map((item) => ({
      ...item,
      label: item.category_name,
      value: item.category_id,
    }));
    setCategory(updatedCategories);
  };

  const getTypeCB = (value) => {
    const updatedTypes = value.data.map((item) => ({
      ...item,
      label: item.filtration_type_name,
      value: item.filtration_type_id
    }));
    setType(updatedTypes);
  };

  const handleBearingChange = (e) => {
    const { name, value } = e.target;
    formDispatch({
      type: "SET_FIELD",
      field: name,
      value,
    })
  }

  const getBearingDetailsOnLoad = (data) => {
    const bearingObj = {}
    const keys = Object.keys(initialState)
    const dataKeys = Object.keys(data)
    keys.filter((key) => {
      if (dataKeys.includes(key)) {
        return bearingObj[key] = data[key]
      }
    })

    Object.entries(bearingObj).map(([key, value]) => {
      formDispatch({
        type: "SET_FIELD",
        field: key,
        value,
      })
    })
  }

  const getProductDataCB = (value) => {
    // console.log(value.result)
    const data = value.data;


    // IMPORTANT: Set all fields first, before checking category_id
    setProductName(data.product_name); // Set product name for all categories
    setBaldwin(data.baldwin);
    setDonaldson(data.donaldson);
    setFileCad(data.upload_cad_drawing);
    setFleetguard(data.fleetguard);
    setHifi(data.hifi);
    setProductBrand(data.product_brand_name);
    setProductSubBrand(data.product_sub_brand_name);
    setSakura(data.sakura);
    setWix(data.wix);
    setMann(data.mann);
    sethengst(data.hengst);
    setExistingSubCategory(data.sub_category_id);
    setMaxViscosity(data.max_viscosity);
    setMountingConnection(data.mounting_connection);
    setHousingOption(data.housing_option
      ? { label: "Yes", value: "Yes" }
      : { label: "No", value: "No" }
    );
    setProductOptions(
      Array.isArray(data.product_option) ? data.product_option : []
    );
    setDescription(data.description);
    setMaxFlowRate(data.max_flow_rate);
    setWorkingPressure(data.working_pressure);
    setRatedStaticBurst(data.rated_static_burst);

    // Set gearbox fields regardless of category
    // This ensures they're always set even if category_id is 4
    setGearboxTorqueRange(data.gearbox_torque_range || "");
    setGearboxRatios(data.gearbox_ratios || "");
    setGearboxMechanicalRating(data.gearbox_mechanical_rating || "");
    setGearboxInput(data.gearbox_input || "");
    setGearboxOutput(data.gearbox_output || "");
    setGearboxSizes(data.gearbox_sizes || []);

    getBearingDetailsOnLoad(data)

    const initialFiles = data?.product_catalog_images.map(({ product_name, ...rest }) => {
      return {
        ...rest,
        "isAdded": false,
        "isDeleted": false,
      };
    });
    setMultiFile(initialFiles);

    // Handle category setting
    const matchingCategory = category.find(
      (item) => item.category_id === data.category_id
    );
    if (matchingCategory) {
      setSelectedCategory(matchingCategory);
      handleDropDownChange(matchingCategory);
    }

    // Fix for filteration type loading
    if (data.filteration_type_id) {
      const matchingType = {
        label: data.filteration_type_name,
        value: data.filteration_type_id
      };
      setSetType(matchingType);
    }
  }

  const handleRemove = (indexToRemove) => {
    setMultiFile((prevMultiFile) =>
      prevMultiFile.map((item, index) => {
        // Check if the current item is at the specified index
        if (index === indexToRemove) {
          // If product_catalog_images_id exists, mark as deleted
          if (item.product_catalog_images_id) {
            return { ...item, isDeleted: true };
          }
          // If no product_catalog_images_id, return null to filter out later
          return null;
        }
        // Leave other items as they are
        return item;
      })
        .filter((item) => item !== null) // Remove items that are set to null
    );
  };



  return (
    <MainLayout pageName={"Product Catalog"}>
      {isSuccess && (
        <SuccessCard
          title="Product Edited Successfully"
          subTitle="Product Details Edited Successfully."
          onClose={() => setIsSuccess(false)}
          onGoBack={() => navigate(-1)}
        />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Product Catalog</p>
      </div>

      <form className="AddProductContainer" onSubmit={handleSubmit}>
        <div className="AddProductContainerHeader">
          <h2>Edit Product Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        {(Number(category_id) !== 4 || Number(category_id) === 2) && Number(category_id) !== 1 &&
          <div className="AddProductInputBoxBody">
            <div className="AddProductInputContainer">
              <p>Category</p>
              <div className="AddProductInputBoxContainer">
                <DropDownBox
                  options={category}
                  placeholder="Bearings"
                  onChange={handleDropDownChange}
                  value={selectedCategory}
                  customStyles={dropDownStyles}
                  disabled={true}
                />
                {errors.category && <ErrorMessage message={errors.category} />}
              </div>
            </div>
            {selectedType?.value === 1
              ?
              <div className="AddProductInputContainer">
                <p>Sub Category</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={subCategory}
                    placeholder="Select Sub Category"
                    onChange={(option) => setSelectedSubCategory(option)}
                    value={selectedSubCategory}
                    customStyles={dropDownStyles}
                  />
                  {errors.sub_category && <ErrorMessage message={errors.sub_category} />}
                </div>
              </div> : ""}
            <div className="AddProductInputContainer">
              <p>Type</p>
              <div className="AddProductInputBoxContainer">
                <DropDownBox
                  options={type.map(item => ({
                    label: item.filtration_type_name,
                    value: item.filtration_type_id
                  }))
                  }

                  placeholder="Select Type"
                  onChange={(option) => setSetType(option)}
                  value={selectedType}
                  customStyles={dropDownStyles}
                  disabled={true}
                />
                {errors.selectedType && <ErrorMessage message={errors.selectedType} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Product Name</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="learningTitle"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
                {errors.productName && <ErrorMessage message={errors.productName} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Product Brand Name (optional)</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="productBrand"
                  value={productBrand}
                  onChange={(e) => setProductBrand(e.target.value)}
                />
                {/* {errors.category && <ErrorMessage message={errors.category} />} */}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Product Sub Brand Name (optional)</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="productSubBrand"
                  value={productSubBrand}
                  onChange={(e) => setProductSubBrand(e.target.value)}
                />
                {/* {errors.productName && <ErrorMessage message={errors.productName} />} */}
              </div>
            </div>

            {/* need to hide baldwin and fleetguard if filter type is not filteration */}
            {selectedType?.value === 1
              ?
              <>
                <div className="AddProductInputContainer">
                  <p>Baldwin</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="baldwin"
                      value={baldwin}
                      onChange={(e) => {
                        setBaldwin(e.target.value);
                      }}
                    />
                    {errors.baldwin && <ErrorMessage message={errors.baldwin} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Fleetguard</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="fleetguard"
                      value={fleetguard}
                      onChange={(e) => {
                        setFleetguard(e.target.value);
                        setErrors({
                          ...errors,
                          fleetguard: "",
                        });
                      }}
                    />
                    {errors.fleetguard && (
                      <ErrorMessage message={errors.fleetguard} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Hifi</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="hifi"
                      value={hifi}
                      onChange={(e) => setHifi(e.target.value)}
                    />
                    {errors.hifi && <ErrorMessage message={errors.hifi} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Sakura</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="sakura"
                      value={sakura}
                      onChange={(e) => setSakura(e.target.value)}
                    />
                    {errors.sakura && <ErrorMessage message={errors.sakura} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Donaldson</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="donaldson"
                      value={donaldson}
                      onChange={(e) => setDonaldson(e.target.value)}
                    />
                    {errors.donaldson && <ErrorMessage message={errors.donaldson} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Hengst</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="hengst"
                      value={hengst}
                      onChange={(e) => sethengst(e.target.value)}
                    />
                    {errors.hengst && <ErrorMessage message={errors.hengst} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Wix</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="wix"
                      value={wix}
                      onChange={(e) => setWix(e.target.value)}
                    />
                    {errors.wix && <ErrorMessage message={errors.wix} />}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Mann</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="mann"
                      value={mann}
                      onChange={(e) => setMann(e.target.value)}
                    />
                    {errors.mann && <ErrorMessage message={errors.mann} />}
                  </div>
                </div>
              </> :
              <>

                <div className="AddProductInputContainer">
                  <p>Max Flow Rate</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="maxFlowRate"
                      value={maxFlowrate}
                      onChange={(e) => {
                        setMaxFlowRate(e.target.value);
                        setErrors({
                          ...errors,
                          maxFlowrate: "",
                        });
                      }}
                    />
                    {errors.maxFlowrate && (
                      <ErrorMessage message={errors.maxFlowrate} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Working Pressure</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="workingPressure"
                      value={workingPressure}
                      onChange={(e) => {
                        setWorkingPressure(e.target.value);
                        setErrors({
                          ...errors,
                          workingPressure: "",
                        });
                      }}
                    />
                    {errors.workingPressure && (
                      <ErrorMessage message={errors.workingPressure} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Rated Static Burst</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="ratedStaticBurst"
                      value={ratedStaticburst}
                      onChange={(e) => {
                        setRatedStaticBurst(e.target.value);
                        setErrors({
                          ...errors,
                          ratedStaticburst: "",
                        });
                      }}
                    />
                    {errors.ratedStaticburst && (
                      <ErrorMessage message={errors.ratedStaticburst} />
                    )}
                  </div>
                </div>


                <div className="AddProductInputContainer">
                  <p>Max Viscosity</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="maxViscosity"
                      value={maxViscosity}
                      onChange={(e) => {
                        setMaxViscosity(e.target.value);
                        setErrors({
                          ...errors,
                          maxViscosity: "",
                        });
                      }}
                    />
                    {errors.maxViscosity && (
                      <ErrorMessage message={errors.maxViscosity} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Mounting Connection</p>
                  <div className="AddProductInputBoxContainer">
                    <InputBox
                      inputStyle={inputBoxStyles}
                      name="mountingConnection"
                      value={mountingConnection}
                      onChange={(e) => {
                        setMountingConnection(e.target.value);
                        setErrors({
                          ...errors,
                          mountingConnection: "",
                        });
                      }}
                    />
                    {errors.mountingConnection && (
                      <ErrorMessage message={errors.mountingConnection} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Housing Option Available</p>
                  <div className="AddProductInputBoxContainer">
                    <DropDownBox
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      placeholder="Select Here"
                      value={housingOption}
                      onChange={(option) => {
                        setHousingOption(option);
                        setErrors({
                          ...errors,
                          housingOption: "",
                        });
                      }}
                      customStyles={dropDownStyles}
                    />
                    {errors.housingOption && (
                      <ErrorMessage message={errors.housingOption} />
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Product Options</p>
                  <div className="AddProductInputBoxContainer" style={{ width: "31vw", cursor: "not-allowed", backgroundColor: "#edebeb", border: "1px solid #B2BEC3", borderRadius: "5px", padding: "1px 2vh 1px 2vh", }} >
                    {Array.isArray(productOptions) && productOptions.length > 0 ? (
                      productOptions.map((opt, index) => (
                        <span key={index} style={{ fontSize: "2.2vh" }}>
                          <strong>{opt.label}</strong>: {opt.value}
                          {index !== productOptions.length - 1 && <>, </>}
                        </span>
                      ))
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </div>
                <div className="AddProductInputContainer">
                  <p>Description</p>
                  <div className="AddProductInputBoxContainer">
                    <TextArea
                      inputStyle={inputBoxDesStyles}
                      placeholder="Enter here"
                      name="description"
                      value={description}
                      onChange={(e) => {
                        setDescription(e.target.value);
                        setErrors({
                          ...errors,
                          description: "",
                        });
                      }}
                    />
                    {errors.description && (
                      <ErrorMessage message={errors.description} />
                    )}
                  </div>
                </div>
              </>
            }

            <div className="AddProductInputContainer">
              <p style={{ marginBottom: "15px" }}>Upload CAD Document (optional)</p>
              <div className="fileUploadContainer">
                <label htmlFor="uploadFile" className="uploadProductFileLabel">
                  Upload
                  <input
                    type="file"
                    id="uploadFile"
                    accept=".pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </label>
              </div>
              {fileCad ?
                <p style={{ marginTop: "1rem" }}>{fileCad.split('---').pop()}
                  {fileCad ? (
                    <span
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setFileCad("")}
                    >
                      X
                    </span>
                  ) : ("")
                  }
                </p> : ''}
            </div>
          </div>
        }
        {Number(category_id) === 4 && (
          <div className="AddProductInputBoxBody">
            <div className="AddProductInputContainer">
              <p>Category</p>
              <div className="AddProductInputBoxContainer">
                <DropDownBox
                  options={category}
                  placeholder="Gearbox/Motors"
                  onChange={handleDropDownChange}
                  value={selectedCategory}
                  customStyles={dropDownStyles}
                  disabled={true}
                />
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Product Name</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="productName"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
                {errors.productName && <ErrorMessage message={errors.productName} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Torque Range</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="gearboxTorqueRange"
                  value={gearboxTorqueRange}
                  onChange={(e) => setGearboxTorqueRange(e.target.value)}
                />
                {errors.gearboxTorqueRange && <ErrorMessage message={errors.gearboxTorqueRange} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Ratios</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="gearboxRatios"
                  value={gearboxRatios}
                  onChange={(e) => setGearboxRatios(e.target.value)}
                />
                {errors.gearboxRatios && <ErrorMessage message={errors.gearboxRatios} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Mechanical Rating</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="gearboxMechanicalRating"
                  value={gearboxMechanicalRating}
                  onChange={(e) => setGearboxMechanicalRating(e.target.value)}
                />
                {errors.gearboxMechanicalRating && <ErrorMessage message={errors.gearboxMechanicalRating} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Sizes </p>
              <div className="AddProductInputBoxContainer">
                <MultiSelectWithCreate
                  initialSelectedSizes={gearboxSizes}
                  onChange={(selectedValues) => {
                    setGearboxSizes(selectedValues);
                  }}
                />
                {errors.gearboxSizes && <ErrorMessage message={errors.gearboxSizes} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Input</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="gearboxInput"
                  value={gearboxInput}
                  onChange={(e) => setGearboxInput(e.target.value)}
                />
                {errors.gearboxInput && <ErrorMessage message={errors.gearboxInput} />}
              </div>
            </div>
            <div className="AddProductInputContainer">
              <p>Gearbox Output</p>
              <div className="AddProductInputBoxContainer">
                <InputBox
                  inputStyle={inputBoxStyles}
                  name="gearboxOutput"
                  value={gearboxOutput}
                  onChange={(e) => setGearboxOutput(e.target.value)}
                />
                {errors.gearboxOutput && <ErrorMessage message={errors.gearboxOutput} />}
              </div>
            </div>
          </div>
        )}
        {Number(category_id) === 1 && (
          <>

            <div className="AddProductInputBoxBody">
              <div className="AddProductInputContainer">
                <p>Category</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={category}
                    placeholder="Bearings"
                    onChange={handleDropDownChange}
                    value={selectedCategory}
                    customStyles={dropDownStyles}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Name</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="productName"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                  {errors.productName && (
                    <ErrorMessage message={errors.productName} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Designation</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="designation"
                    value={state.designation}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.designation && (
                    <ErrorMessage message={errors.designation} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Suffix</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="suffix"
                    value={state.suffix}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.suffix && (
                    <ErrorMessage message={errors.suffix} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Performance Class</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="performance_class"
                    value={state.performance_class}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.performance_class && (
                    <ErrorMessage message={errors.performance_class} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Radial Internal Clearance</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="radial_internal_clearance_um"
                    value={state.radial_internal_clearance_um}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.radial_internal_clearance_um && (
                    <ErrorMessage message={errors.radial_internal_clearance_um} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Features</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="features"
                    value={state.features}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.features && (
                    <ErrorMessage message={errors.features} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Bearing Type</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="bearing_type"
                    value={state.bearing_type}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.bearing_type && (
                    <ErrorMessage message={errors.bearing_type} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Bore Size(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="bore_size_d_mm"
                    value={state.bore_size_d_mm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.bore_size_d_mm && (
                    <ErrorMessage message={errors.bore_size_d_mm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Outside Diameter(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="outside_diameter_d_mm"
                    value={state.outside_diameter_d_mm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.outside_diameter_d_mm && (
                    <ErrorMessage message={errors.outside_diameter_d_mm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Outside Ring Width(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="outside_ring_width_b_mm"
                    value={state.outside_ring_width_b_mm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.outside_ring_width_b_mm && (
                    <ErrorMessage message={errors.outside_ring_width_b_mm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Radius</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="radius_rs_min_mm"
                    value={state.radius_rs_min_mm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.radius_rs_min_mm && (
                    <ErrorMessage message={errors.radius_rs_min_mm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Dynamic Load Rating</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="dynamic_load_rating_cr_n"
                    value={state.dynamic_load_rating_cr_n}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.dynamic_load_rating_cr_n && (
                    <ErrorMessage message={errors.dynamic_load_rating_cr_n} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Static Load Rating</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="static_load_rating_c0r_n"
                    value={state.static_load_rating_c0r_n}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.static_load_rating_c0r_n && (
                    <ErrorMessage message={errors.static_load_rating_c0r_n} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Reference Speed(rpm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="reference_speed_rpm"
                    value={state.reference_speed_rpm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.reference_speed_rpm && (
                    <ErrorMessage message={errors.reference_speed_rpm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Limiting Speed(rpm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="limiting_speed_rpm"
                    value={state.limiting_speed_rpm}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.limiting_speed_rpm && (
                    <ErrorMessage message={errors.limiting_speed_rpm} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Mass(kg)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="mass_kg"
                    value={state.mass_kg}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.mass_kg && (
                    <ErrorMessage message={errors.mass_kg} />
                  )}
                </div>
              </div>

            </div>
          </>
        )}
        <div>
        </div>
        <p style={{ fontWeight: '700', marginTop: '15px' }}>Upload Product Images</p>
        <div className="multipleProductImageUpload">
          <label htmlFor="uploadMultipleFile" className="uploadProductFileLabelEdit" style={{ cursor: 'pointer' }}>
            <img src={assets.Icons.uploadIcon} alt="upload Icon" />
            Upload Multiple Files
            <input
              multiple
              type='file'
              id="uploadMultipleFile"
              accept=".jpg,.jpeg,.png,.webp"
              style={{ display: "none" }}
              onChange={handleMultipleFileChange}
            />
          </label>
          <div className="productImagesContainer">
            {multiFile.length > 0 ?
              multiFile.map((item, index) => {
                console.log(item)
                return (
                  item.isDeleted !== true &&
                  (<div key={index} className="individualProductImageContainer">
                    <p onClick={() => handleRemove(index)} style={{ cursor: "pointer" }}>X</p>
                    <img src={item.product_catalog_images} alt="product" />
                  </div>)
                )
              })
              : ""}
          </div>
        </div>
        <div className="addStaffButtons">
          <div className="addStaffButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addStaffButtonContainer">
            <Button forForm={true} buttonStyle={{ height: "2vh" }} title="Save" />
          </div>
        </div>
      </form>
    </MainLayout >
  );
};

export default EditProductCatalog;
